import type { ExcludeStringLiteral, Server } from '@festina-life/core'

import { useHook } from '../../lenteHooks'

export type StackTraceSupportedComponent = ExcludeStringLiteral<
  Server,
  | 'configuration'
  | 'dataMart'
  | 'dataMart2'
  | 'legalEntityDataReplicator'
  | 'lifeDataReplicator'
  | 'unitLinkDataReplicator'
  | 'collCalc'
>

type Props = {
  stopStackTraceId: string
  component: StackTraceSupportedComponent
}

export const useFetchStackTrace = ({ stopStackTraceId, component }: Props) => {
  const tenantId = useHook('routing.tenant.useTenantParam')()
  const life = useHook('fetchers.life.useFetchLifeStackTrace')
  const moneyIn = useHook('fetchers.moneyIn.useFetchMoneyInStackTrace')
  const moneyOut = useHook('fetchers.moneyOut.useFetchMoneyOutStackTrace')
  const unitLink = useHook('fetchers.unitlink.useFetchUnitlinkStackTrace')
  const legalEntity = useHook('fetchers.crm.useFetchLegalEntityStackTrace')

  return {
    life,
    moneyIn,
    moneyOut,
    unitLink,
    legalEntity,
  }[component]({ id: stopStackTraceId, tenantId })
}
